import React, { useEffect, useState } from 'react';
import { Row, Menu, Dropdown, Button, Col, Spin, Pagination, Input, message, Typography } from 'antd';
import GigItem from "../GigListing/GigListing";
import HomeCategoryCard from "../../../components/HomeCategoryCard/HomeCategoryCard";
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import Loader from '../../../components/Loading/Loader';
import { DownOutlined, UserOutlined } from '@ant-design/icons';
import { getGigs } from '../../../redux/actions';
import MobilePagination from '../../../components/Pagination/MobilePagination';

const GigsTypes = [
    {
        name: 'All gigs',
        key: 'all',
    },
    {
        name: 'Draft gigs',
        key: 'Draft',
    },
    {
        name: 'Published gigs',
        key: 'Published',
    },
    {
        name: 'Expired gigs',
        key: 'Expired',
    },
    {
        name: 'Closed gigs',
        key: 'Closed',
    },
    {
        name: 'Gigs with matches',
        key: 'Matches',
    },

]

const pageSize = 12;

export default function ViewGigs() {

    const { Search } = Input;
    const { Title } = Typography;

    const dispatch = useDispatch();
    const history = useHistory();

    const [windowDimensions, setWindowDimensions] = useState(
        getWindowDimensions()
      );
    const [selectedBidType, setSelectedBidType] = useState('All Gigs');
    const [selectedBidStatus, setSelectedBidStatus] = useState('all');
    const [currentPage, setCurrentPage] = useState(1);
    const [count, setCount] = useState(0);
    const [search, setSearch] = useState('$')
    const gigsResp = useSelector(state => state.getGigsReducer.gigs);
    const loading = useSelector(state => state.getGigsReducer.loading);
    const error = useSelector(state => state.getGigsReducer.error);

    useEffect(() => {
        function handleResize() {
          setWindowDimensions(getWindowDimensions());
        }
    
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
      }, []);
    useEffect(() => {
        searchBids();
    }, [search]);

    useEffect(() => {
        setCount(gigsResp.length);
    }, [gigsResp])

    function getWindowDimensions() {
        const { innerWidth: width, innerHeight: height } = window;
        return {
          width,
          height,
        };
      }
    const searchBids = () => {
        dispatch(getGigs(
            {selectedBidStatus,
                search,
                currentPage,
                pageSize 
            }));
        // console.log("selectedBidStatus: ",selectedBidStatus,"search: ",search,"page: ",currentPage,"pageSize: ",pageSize);
    }


    const onChangePage = (page) => {
        // console.log(selectedBidType+' '+ page * (pageSize - 1))

        // searchBids(selectedBidStatus, page * (pageSize - 1));
        setCurrentPage(page);
    }

    const onSearch = value => {
        if (value) {
            setSearch(value)
        }
        else {
            setSearch('$')
        }



    }
    const onDropDownItemCLick = (bidType, key) => {
        setSelectedBidType(bidType);
        setSelectedBidStatus(key);
        setCurrentPage(1);
        searchBids(key, 0);
    }


    const menu = (
        <Menu>
            {
                GigsTypes.map((item) => (
                    <Menu.Item
                        key={item.key}
                        className={item.name === selectedBidType ? 'placed-bid-dropdown-item' : ''}
                        onClick={() => onDropDownItemCLick(item.name, item.key)}
                    >
                        {item.name}
                    </Menu.Item>
                ))
            }
        </Menu>
    );
if(gigsResp.length!==0){


    return (
        // <div>
        //     <GigListing />
        //     <GigListing />
        //     <GigListing />
        //     <GigListing />
        // </div>
        <div >
        <HomeCategoryCard
            count={gigsResp.aggregate.totalCount}
            title={'My Gigs'}

            searchBar={

                <Search placeholder="Search" allowClear onSearch={(val)=>onSearch(val)} style={{width:'96%'}} size='large' />
            }
            dropdown={
                <Dropdown overlay={menu} >
                    <Button style={{ width: '100%', height: '41px' }}>
                        {selectedBidType} <DownOutlined style={{ marginLeft: '60%' }} />
                    </Button>
                </Dropdown>
            }
            buttonClear={
                <Button type="primary" size="middle" style={{width:'90%', borderRadius:'6px' , marginLeft:'8%'}} onClick={()=>setSearch('$')}>Clear</Button>
            }
            elementBottom={
                gigsResp.length!==0 ?
                     windowDimensions.width > 769 ? 
                        <div style={{ margin: "auto" }}>
                        <Pagination
                            defaultCurrent={1}
                            current={currentPage}
                            total={gigsResp.aggregate.totalCount}
                            defaultPageSize={pageSize}
                            onChange={(page) => onChangePage(page)}
                        />
                    </div> : 
                    <div style={{width:'100%'}}>
                    <MobilePagination
                      span={24}
                      current={currentPage}
                      defaultPageSize={pageSize}
                      total={gigsResp.aggregate.totalCount}
                      onChange={(page) => onChangePage(page)}
                    />
                  </div>
                  :
                  null
            }
            items={
                <Row style={{ width: '100%' ,}}>
                    {
                        loading
                            ?
                            <div className={'bids-spin'}>
                                <Spin />
                            </div>
                            : 33/3/
                            
                            gigsResp.userGigs.map((item, index) => {

                                return (
                                    <GigItem
                                        // onEdit={() => onEditPress(item._id)}
                                        // {...item}
                                        key={index}
                                        item={item}
                                    />
                                )
                            }
                            )

                    }
                </Row>

            }
        >
            {/* <Row>
                {
                    loading
                        ?
                        <div className={'bids-spin'}>
                            <Spin />
                        </div>
                        :
                        manageBids.map((item) => {

                            console.log("ITEM: ",item)
                            return(
                            <PlacedBidItem
                                // onEdit={() => onEditPress(item._id)}
                                // {...item}
                                item={item}
                            />
                            )
                        }
                        )
                    
                }
            </Row> */}
        </HomeCategoryCard>
    </div>
    )
        }
        else{
            return <Loader/>
        }
}